<template>
  <div class="filter-container">
    <div class="catergory-title">IDEAS Catergory</div>
    <el-checkbox-group class="catergory-select" v-model="ideaCategory">
      <el-checkbox class="catergory-item" label="Innovation"></el-checkbox>
      <el-checkbox class="catergory-item" label="Discipline"></el-checkbox>
      <el-checkbox class="catergory-item" label="Exposure"></el-checkbox>
      <el-checkbox class="catergory-item" label="Adventure"></el-checkbox>
      <el-checkbox class="catergory-item" label="Synergy"></el-checkbox>
    </el-checkbox-group>
    <el-divider></el-divider>
    <div class="school-select-wrap">
      <div class="school-select-item">
        <div class="select-title">District</div>
        <el-select
          class="select-body"
          v-model="schoolSearchParams.districtCode"
          placeholder="Pleace select"
          @change="getSchoolList"
        >
          <el-option
            v-for="item in districtList"
            :key="item.districtCode"
            :label="item.districtNameEn"
            :value="item.districtCode"
          >
          </el-option>
        </el-select>
      </div>
      <div class="school-select-item">
        <div class="select-title">School Level</div>
        <el-select
          class="select-body"
          v-model="schoolSearchParams.schoolLevel"
          placeholder="Pleace select"
          @change="getSchoolList"
        >
          <el-option
            v-for="item in schoolLevel"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row table-responsive" style="padding-bottom: 60px">
      <el-table
        :header-row-style="{ 'background-color': '#EBEBEB', color: '#676a6c' }"
        :data="schoolList"
        style="width: 100%"
        ref="multipleTable"
        :fit="true"
        class="rowss"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          label="School Name"
          prop="schoolName"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <el-col :span="24" class="el-table_footertoolbar">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="schoolSearchParams.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <div class="bottom-button-wrap">
      <el-button class="bottom-button" @click="handleClear"
        >Clear</el-button
      >
      <el-button
        class="bottom-button"
        type="primary"
        @click="handleFilter"
        >Filter</el-button
      >
    </div>
  </div>
</template>

<script>
import config from "../../../config";
export default {
  mixins: [config.globalMixin],
  name: "filterContent",
  components: {},
  created() {
    this.getDistrictList();
    
  },
  props:{
    searchParam:{
      type:Object,
      default:()=>{
        return {
          ideaCategory:[],
          schoolCode:[],
          districtCode:''
        }
      }
    }
  },
  watch:{
    searchParam: {
      handler: function(e) {
        this.ideaCategory = e.ideaCategory
        this.schoolCode = e.schoolCode
        this.schoolSearchParams.districtCode=e.districtCode
      },
      deep: true,
      immediate:true
    }
  },
  data() {
    return {
      ideaCategory: [],
      schoolCode: [],
      schoolSearchParams: {
        pageSize: 5,
        pageIndex: 1,
        schoolLevel: "",
        districtCode: "",
      },
      total: 0,
      districtList: [],
      schoolList: [],
    };
  },
  mounted(){
    this.getSchoolList();
  },
  computed: {
    schoolLevel() {
      return [{ key: 1, label: "Primary School" },{key:2,label:"Secondery school"}];
    }
  },
  methods: {
    async getDistrictList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtList", data.data.result);
    },
    async getSchoolList() {
      let obj = this.getAuthObj();
      obj.apiUrl = "/school/list";
      const params = {
        ...obj,
        ...this.schoolSearchParams,
      };
      let data = await this.$store.dispatch("apiEvent", params);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.total=data.data.result.total
      this.schoolList = data.data.result.schools;
    },
    handleCurrentChange(val) {
      this.schoolSearchParams.pageIndex = val
      this.getSchoolList();
    },
    handleSelectionChange(e) {
      this.schoolCode = e;
    },
    handleClear() {
      this.ideaCategory = []
      this.schoolCode = []
      this.schoolSearchParams = {
        pageSize: 5,
        pageIndex: 1,
        schoolLevel: "",
        districtCode: "",
      };
      this.getSchoolList();
      const params = {
        ideaCategory:this.ideaCategory,
        schoolCode: this.schoolCode,
      }
      this.$emit("clear",params);
    },
    handleFilter() {
      const params = {
        ideaCategory:this.ideaCategory,
        schoolCode: this.schoolCode,
        districtCode: this.schoolSearchParams.districtCode,
      }
      this.$emit("filter",params);
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.table-responsive {
  margin: 0 !important;
}
.filter-container {
  width: 100%;
  .catergory-title {
    margin-bottom: 20px;
    color: rgb(48, 49, 51);
  }
  .catergory-select {
    margin-bottom: 22px;
    .catergory-item {
      margin-right: 82px;
    }
    .catergory-item:last-child {
      margin-right: 0;
    }
  }
  .school-select-wrap {
    display: flex;
    margin: 20px 0;
    .school-select-item {
      margin-right: 62px;
      display: flex;
      align-items: center;
      .select-title {
        margin-right: 20px;
        min-width: fit-content;
      }
      .select-body {
        height: 40px;
        width: 295px;
      }
    }
    .school-select-item:last-child {
      margin-right: 0;
    }
  }
  .bottom-button-wrap {
    display: flex;
    justify-content: center;
    .bottom-button {
      margin-right: 10px;
    }
    .bottom-button:last-child {
      margin-right: 0;
    }
  }
}
</style>
